import cn from 'classnames'
import * as React from 'react'

import { AppButton } from 'components/AppButton'
import { AppSelect } from 'components/AppSelect'

import { ReactComponent as SearchIcon } from 'assets/images/svg/search.svg'

import styles from './AppLayoutTable.module.scss'

interface Props {
  title: string
  onChangeQuery?(query: string): void
  onChangeSort?(type: string): void
  statistics?: React.ReactNode
  sidebar?: React.ReactNode
  button?: {
    text: string
    onClick(): void
  }
  header?: React.ReactNode
  sidebarOpened?: boolean
}

export const AppLayoutTable: React.FC<Props> = ({
  title,
  onChangeQuery,
  onChangeSort,
  children,
  sidebar,
  header,
  button,
  statistics,
  sidebarOpened,
}) => {
  return (
    <>
      {header ? (
        <div className="wrapper">
          <header className={styles.query}>
            <details open>
              <summary className={styles.queryTitle}>
                Выберите параметры
              </summary>
              <br />
              {header}
            </details>
          </header>
        </div>
      ) : null}
      <div className={cn('container', styles.content)}>
        <div
          className={cn(styles.children, {
            [styles.opened]: sidebarOpened,
          })}
        >
          <div className={styles.headerContainer}>
            <div className={styles.header}>
              <h1 className={styles.title}>{title}</h1>
              {onChangeQuery ? (
                <div className={styles.searchContainer}>
                  <SearchIcon />
                  <input
                    onChange={({ target: { value } }) => {
                      onChangeQuery(value)
                    }}
                    className={styles.search}
                    type="text"
                    placeholder="Поиск"
                  />
                </div>
              ) : null}
              {button ? (
                <div className={styles.button}>
                  <div>
                    <AppButton variant="siren" onClick={button.onClick}>
                      {button.text}
                    </AppButton>
                  </div>
                </div>
              ) : null}
              {false ? (
                <div className={styles.sort}>
                  <div className={styles.sortTitle}>Сортировать</div>
                  <div className={styles.sortInput}>
                    <AppSelect
                      onChangeValues={values => {
                        if (values?.[0]) {
                          onChangeSort?.(values[0])
                        }
                      }}
                      containerClassName={styles.sortInputSelect}
                      size="small"
                      list={[
                        {
                          title: 'yes',
                          value: '',
                        },
                      ]}
                    />
                  </div>
                </div>
              ) : null}
            </div>
            {statistics ? (
              <div className={styles.statistics}>{statistics}</div>
            ) : null}
          </div>
          {children}
        </div>
        {sidebar ? <div className={styles.sidebar}>{sidebar}</div> : null}
      </div>
    </>
  )
}
